import * as Yup from 'yup';

export const subdivisioneValidationSchema = Yup.object().shape({
  id: Yup.number()
    .required('El ID es obligatorio')
    .typeError('El ID debe ser un número válido'),

  descripcion: Yup.string()
    .required('El nombre es obligatorio')
    .typeError('El nombre debe ser una cadena de texto válida'),
});

export const validateSubdivisioneForm = async (formData) => {
  try {
    await subdivisioneValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};
